import { takeEvery, fork, all, call, put } from "redux-saga/effects";
import { post } from "helpers/api_helper";

// Account Redux states
import { REGISTER_USER } from "./actionTypes";
import { registerUserSuccessful, registerUserFailed } from "./actions";

const newRegister = async (user) => await post('/auth/registration', user);

// When user registers successfully, update redux and navigate to login
function* registerUser({ payload: { user } }) {
  try {
    const response = yield call(newRegister, user);
    if (response && response.success !== false) {
      yield put(registerUserSuccessful(response.data || user));
      setTimeout(() => {
        window.location.href = '/login';
      }, 1500);
    } else {
      yield put(registerUserFailed(response?.message || response?.error || 'Registration failed. Please check your details.'));
    }
  } catch (error) {
    const errorMsg = 
      error?.response?.data?.message || 
      error?.response?.data?.error || 
      error?.message || 
      'Registration failed. Please try again.';
    yield put(registerUserFailed(errorMsg));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
